import axios from "axios";

const state = {
  doctor_sign_img: "",
  doctor_profile_img: "",
};

const getters = {};

const actions = {
  async get_sign_image({ commit },) {
    try {
      const config = {
        params:{
          biz_id:sessionStorage.getItem("biz_id")
        }
      };
      await axios
        .get(
          `${process.env.VUE_APP_BACKEND_URL}/v1/sign/get-sign-image`,
          config
        )
        .then((res) => {
          if (res.data.data && res.data.result === "success") {
            commit("set_doctor_sign_img", res.data.data);
          } else {
            commit("set_doctor_sign_img", "");
          }
        })
        .catch((err) => {
          console.log("axios get sign image catch err:", err);
        });
    } catch (error) {
      console.log("get sign image catch err:", error);
    }
  },
  async add_sign_image({ commit }, data) {
    try {
      const payload = {
        biz_id:sessionStorage.getItem("biz_id"),
        imageSign: data.sign,
      };
      await axios
        .post(
          `${process.env.VUE_APP_BACKEND_URL}/v1/sign/add-sign-image`,
          // `http://localhost:5000/v1/sign/add-sign-image`,
          payload,
        )
        .then(() => {
          commit("set_doctor_sign_img", data.sign);
        })
        .catch((err) => {
          console.log("axios get sign image catch err:", err);
        });
    } catch (error) {
      console.log("get sign image catch err:", error);
    }
  },
};

const mutations = {
  set_doctor_sign_img(state, data) {
    state.doctor_sign_img = data;
  },
  set_image_profile(state, data) {
    state.doctor_profile_img = data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
